import {
  Chip as UnstyledChip,
  FormControl as UnstyledFormControl,
  InputLabel as UnstyledInputLabel,
  styled,
} from "@mui/material";

import { style } from "@citrine/theme/style";

import { Row } from "../layout";

export const Chips = styled(Row)({
  flexWrap: "nowrap",
});

export const Chip = styled(UnstyledChip)(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

export const Value = styled("span")({
  flex: 1,
  lineHeight: "1.2em",
  overflow: "hidden",
  textOverflow: "ellipsis",
});

export const menu = style((theme) => ({
  "& .MuiMenu-paper": {
    maxHeight: `calc(100% - ${theme.spacing(25)})`,
  },
  "& .MuiMenu-list": {
    backgroundColor: "inherit",
    border: "none",
    // needed to prevent scrollbar
    margin: theme.spacing(0.5),
  },
}));

export const InputLabel = styled(UnstyledInputLabel)({
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
});

export const FormControl = styled(UnstyledFormControl)(({ theme }) => ({
  minWidth: theme.spacing(15),
  maxWidth: "100%",
}));
